import React from "react";

// Free-tier promotional banner. Renders only when the caller decides to show it
// (the parent gates on subscription tier so the design system stays decoupled).
const CalloutBanner = ({ isMobile }) => (
  <div
    className={`contract-callout ${isMobile ? "mobile" : ""}`}
    role="complementary"
    aria-label="Contract management upsell"
  >
    <div className="contract-callout-body">
      <p className="contract-callout-headline">
        Your inspection, your rules. All in a{" "}
        <span className="contract-callout-accent">signed agreement</span>.
      </p>
      <p className="contract-callout-subhead">
        Keep every job professional and on the record — contracts signed,
        stored, and ready.
      </p>
    </div>
  </div>
);

export default CalloutBanner;
